import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getMyBids(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/auctions/my-bids?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getAuctionTracking(filters) {
  const { auctionId } = filters;

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(
      `${endpoint}/auctions/tracking/${auctionId}`,
      config
    );
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

export { getMyBids, getAuctionTracking };
